/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { ReactElement } from 'react';
import { ChartItemKeys, chartSeriesContent, ChartType } from '../ChartSeriesItems';
import ChartWrapper from './ChartWrapper';
import { getLineChartDefaultOptions } from './FlDataRateChart';
import { withTerminalHistoryChartHOCAndNoDataAvailableHOC } from './WithTerminalHistoryChartHOC';

interface PowerChartProps {
  index: number;
  text: string;
  id: string;
  children: ReactElement | ReactElement[];
}

const PowerChart = (props: PowerChartProps) => {
  const { index, text, id, children } = props;
  const chartName = text;

  return (
    <ChartWrapper name={chartName} id={id} index={index} chartType={ChartItemKeys.power}>
      {children}
    </ChartWrapper>
  );
};

export default withTerminalHistoryChartHOCAndNoDataAvailableHOC(
  PowerChart,
  ChartType.line,
  getLineChartDefaultOptions('dB', true, (value: number) => `${value} dB`),
  chartSeriesContent[ChartItemKeys.power],
  'powerGapSec',
);
export { PowerChart as PowerChartComponent };